
import React, { useState } from 'react';
import './column.css';

const Column = ({ text1, text2, text3, isBack }) => {

  return (
    <>
      {!isBack ? (
        <>
          <div className="content_column">
            <div className="column_text">
              {text1}
            </div>
            <div className="column_text">
              {text2}
            </div>
            <div className="column_text2">
              {text3}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="content_column_revers">
            <div className="column_text">
              {text1}
            </div>
            <div className="column_text">
              {text2}
            </div>
            <div className="column_text2">
              {text3}
            </div>
          </div>
        </>

      )
      }
    </>

  )
}

export default Column;